<script>
export default {
  components: {},
  props: {},
  emits: [],
  data() {
    return {
      Filtri: [
        {id: 0, filter: 'Učitelj', status: false},
        {id: 1, filter: 'Klub letala', status: false},
        {id: 3, filter: 'Klub pilota', status: false},
        {id: 4, filter: 'Klub učitelja', status: false},
        {id: 5, filter: 'Kraj pristanka', status: false},
        {id: 6, filter: 'Kraj vzleta', status: false}
      ]
    }
  },
  mounted() {

  },
  computed: {},
  methods: {}
}
</script>
<template>
  <div class="p-2 rounded-4">
    <div class="container p-2">
      <!-- <i class="fas fa-search text-black shadow"></i> &nbsp; -->
      <!-- <input class="naslov-drop-down p-2 input-dropdown border-0 rounded-3 shadow" placeholder="Išči / Filtriraj"/> -->
      <div class="notranjost-drop-down container p-2">
        <div v-for="(id, index) in Filtri" :key="index" class="p-2 shadow col-12">
          <label class=" col-10">{{ id.filter }}</label>
          <input class="checkbox-input col-2 col-start-8" style="scale:1.5;" type="checkbox" v-model="id.status" value="true"/>
        </div>
      </div>
    </div>
  </div>
</template>